import { defineMessages } from 'react-intl'

export const availableLicensesMessages = defineMessages({
  modalApplyTitle: {
    id: 'availableLicenses.modalApplyTitle',
    description:
      'Title for confirm modal that asks if user wants to apply the chosen license on this home/host',
    defaultMessage: 'Apply License?',
  },
  modalApplyText: {
    id: 'availableLicenses.modalApplyText',
    description:
      'Text of confirm modal that asks if user wants to apply the chosen license on this home/host',
    defaultMessage:
      '{licenseName} will be applied to {homeName}. {br} This action is final and cannot be undone.',
  },
  modalInfoTitle: {
    id: 'availableLicenses.modalInfoTitle',
    description: 'Title for info modal confirming license is applied',
    defaultMessage: 'License Applied',
  },
  modalErrorTitle: {
    id: 'availableLicenses.modalErrorTitle',
    description: 'Title for info modal error applying license',
    defaultMessage: 'Licensing Error',
  },
  modalHomeOfflineText: {
    id: 'availableLicenses.modalHomeOfflineText',
    description: 'Error message for home offline',
    defaultMessage: 'Cannot license {homeName} while it is offline',
  },
  modalActivatedDate: {
    id: 'availableLicenses.modalActivatedDate',
    description: 'Text confirming the activated date',
    defaultMessage:
      '1 year of Savant Essentials has {br} successfully been added to this home.',
  },
  modalExpiresDate: {
    id: 'availableLicenses.modalExpiresDate',
    description: 'Text confirming the expiration date',
    defaultMessage:
      'Savant Essentials now expires on {br} {date} for this home.',
  },
})
